// extracted by mini-css-extract-plugin
export default {"details__header":"styles_details__header__4sWuT","details__info":"styles_details__info__Jw2UT","details__status":"styles_details__status__TLYT+"};